import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import Button from "../../components/Button";
import { useTranslation } from "../../i18n/TranslationProvider";

// Shown to an admin who has registered and selected a plan (which now
// triggers a MailerSend notification to the team instead of a Stripe
// checkout) but whose payment/verification hasn't been confirmed yet.
// Sits in between "chose a plan" and "hasPaid / isVerified" becoming true.
const PaymentProcessing = () => {
  const { userProfile, logout } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/", { replace: true });
  };

  return (
    <div className="custom-container mx-auto w-4/5 md:w-2/3 lg:w-1/2 text-center">
      <div className="flex flex-col items-center gap-4 py-12">
        <h3 className="text-lg md:text-2xl mb-2">
          {t("payment.processingHeading")}
        </h3>

        <p className="max-w-md">
          {t("payment.processingSubtext")}
        </p>

        <p className="text-sm text-gray-500 max-w-md">
          {t("payment.processingContactNotePrefix")}{" "}
          <Link to="/help" className="text-primary hover:underline">
            {t("payment.processingContactLinkText")}
          </Link>
          .
        </p>

        <Button variant="outline" onClick={handleLogout} className="mt-4">
          {t("header.logout")}
        </Button>
      </div>
    </div>
  );
};

export default PaymentProcessing;